module.exports = __webpack_public_path__ + "img/delete.7aa09a18.svg";